@if (mode() === formMode.VIEW) {
  <div class="row g-3 align-items-stretch claim-detail-columns claim-detail-columns--view">
    <!-- Columna izquierda: datos + dirección -->
    <div class="col-md-5 d-flex">
      <div class="panel h-100 w-100 d-flex flex-column">
        <div class="panel-body p-3 flex-grow-1">
        <div class="claim-detail-view d-flex flex-column gap-3">
          <div class="row g-3">
            <div class="col-6 col-md-6">
              <div class="form-group pb-2">
                <label class="fw-semibold text-muted small text-uppercase">Fecha del Siniestro</label>
                <div class="fs-6 fw-bold text-dark">{{ (dateOfLoss() | date:'dd/MM/yyyy') ?? 'No registrada' }}</div>
              </div>
            </div>
            <div class="col-6 col-md-6">
              <div class="form-group pb-2">
                <label class="fw-semibold text-muted small text-uppercase">Negligencia</label>
                @if (canToggleNegligence) {
                  <div class="form-check form-switch pt-1">
                    <input class="form-check-input ms-0" type="checkbox" id="detailIsNegligenceAdmin"
                           [ngModel]="isNegligence()" (ngModelChange)="onNegligenceToggle($event)">
                    <label class="form-check-label fw-bold ms-3 text-dark small" for="detailIsNegligenceAdmin">
                      {{ isNegligence() ? 'Sí' : 'No' }}
                    </label>
                  </div>
                } @else {
                  <div class="fs-6 fw-bold text-dark">{{ isNegligence() ? 'Sí' : 'No' }}</div>
                }
              </div>
            </div>
            <div class="col-12">
              <div class="form-group pb-2">
                <label class="fw-semibold text-muted small text-uppercase">Conductor del Vehículo</label>
                <div class="fs-6 fw-bold text-dark">
                  @if (isDriverSameAsParty()) {
                    Socio ({{ partyData()?.names }} {{ partyData()?.lastNames }})
                  } @else {
                    {{ driverName() }} (RUT: {{ driverLicense() }} | Clase: {{ driverLicenseClass() }})
                  }
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group pb-2 form-group--stack">
                <label class="fw-semibold text-muted small text-uppercase">Ubicación</label>
                @if (geographicLocation() || (latitude() != null && longitude() != null)) {
                  <div class="claim-detail-location-meta">
                    <div class="claim-detail-location-saved d-flex flex-wrap align-items-baseline gap-2">
                      <span class="text-break">
                        <i class="fas fa-map-marker-alt me-1 text-danger"></i>
                        <strong class="fs-6 text-dark">{{ geographicLocation() || 'Sin dirección' }}</strong>
                      </span>
                      @if (latitude() != null && longitude() != null) {
                        <button type="button" class="btn btn-link btn-sm px-0 py-0 align-baseline"
                          (click)="openLocationOnMap()">
                          <i class="fas fa-map me-1"></i>Ver en mapa
                        </button>
                      }
                    </div>
                    @if (latitude() != null && longitude() != null) {
                      <div class="claim-detail-location-coords text-muted small mt-1">
                        Lat: {{ latitude() | number:'1.5-5' }} · Lng: {{ longitude() | number:'1.5-5' }}
                      </div>
                    }
                  </div>
                } @else {
                  <div class="text-muted">Sin ubicación registrada</div>
                }
              </div>
            </div>
            <div class="col-12">
              <div class="form-group pb-2 form-group--stack">
                <label class="fw-semibold text-muted small text-uppercase">Descripción / Reseña del Accidente</label>
                <div class="text-dark text-break">{{ description() || 'Sin descripción' }}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group pb-2 form-group--stack">
                <label class="fw-semibold text-muted small text-uppercase">Descripción de los Daños Físicos</label>
                <div class="text-dark text-break">{{ damageDescription() || 'Sin descripción' }}</div>
              </div>
            </div>
          </div>

          @if (!isTotalLoss()) {
            <div class="row g-3 claim-detail-costs">
              <div class="col-6 col-md-4">
                <div class="form-group pb-2">
                  <label class="fw-semibold text-muted small text-uppercase">Mano de Obra</label>
                  <div class="fs-6 fw-bold text-dark">{{ laborCost() > 0 ? '$' + (laborCost() | number:'1.0-0':'es-CL') : '$0' }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="form-group pb-2">
                  <label class="fw-semibold text-muted small text-uppercase">Repuestos / Pintura</label>
                  <div class="fs-6 fw-bold text-dark">{{ partsCost() > 0 ? '$' + (partsCost() | number:'1.0-0':'es-CL') : '$0' }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="form-group pb-2">
                  <label class="fw-semibold text-muted small text-uppercase">Total Costo</label>
                  <div class="fs-6 fw-bold text-dark">{{ (laborCost() + partsCost()) > 0 ? '$' + ((laborCost() + partsCost()) | number:'1.0-0':'es-CL') : '$0' }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="form-group pb-2">
                  <label class="fw-semibold text-muted small text-uppercase">Deducible línea</label>
                  <div class="fs-6 fw-bold text-danger">${{ deductible() | number:'1.0-0':'es-CL' }}</div>
                </div>
              </div>
            </div>
          } @else {
            <div class="row g-3 claim-detail-costs">
              <div class="col-6">
                <div class="form-group pb-2">
                  <label class="fw-semibold text-muted small text-uppercase">Valor Comercial</label>
                  <div class="fs-6 fw-bold text-dark">${{ vehicleValue() | number:'1.0-0':'es-CL' }}</div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group pb-2">
                  <label class="fw-semibold text-muted small text-uppercase">Retención</label>
                  <div class="fs-6 fw-bold text-danger">${{ deductible() | number:'1.0-0':'es-CL' }}</div>
                </div>
              </div>
            </div>
          }
        </div>
        </div>
      </div>
    </div>

    <!-- Columna derecha: vehículo normal (sin mapa) -->
    <div class="col-md-7 d-flex">
      @if (!isTotalLoss()) {
        <div class="panel h-100 w-100 d-flex flex-column claim-detail-view-vehicle">
          <div class="panel-header p-3 mb-0 bg-none d-flex justify-content-between align-items-center">
            <span class="fw-semibold"><i class="fas fa-car me-2"></i>Partes afectadas</span>
            <span class="badge bg-secondary text-uppercase">{{ selectedVehicleType() }}</span>
          </div>
          <div class="panel-body p-3 pt-0 flex-grow-1 d-flex">
            <app-vehicle-damage-selector
              class="w-100"
              [vehicleType]="selectedVehicleType()"
              [initialSelectedParts]="affectedParts()"
              [readOnly]="true"
              [showSelectedList]="true"
              [compact]="false"
              [tabsOnTop]="true">
            </app-vehicle-damage-selector>
          </div>
        </div>
      } @else {
        <div class="panel h-100 w-100 d-flex align-items-center justify-content-center text-muted p-4">
          <span><i class="fas fa-car-crash me-2"></i>Pérdida total — sin selector de partes</span>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="row g-3 align-items-stretch claim-detail-columns">
    <!-- Columna izquierda: Formulario interactivo -->
    <div class="col-md-6 d-flex">
      <div class="panel h-100 w-100 d-flex flex-column">
        <div class="panel-body p-3 flex-grow-1">
          <div class="mb-3">
            <label class="form-label fw-semibold text-dark small">Fecha del Siniestro *</label>
            <input type="date" class="form-control form-control-sm"
              [min]="minDate()" [max]="maxDate()"
              [ngModel]="dateOfLoss()" (ngModelChange)="dateOfLoss.set($event); updateModel()">
            <span class="text-muted d-block mt-1" style="font-size: 10px;">
              <i class="fas fa-info-circle me-1"></i>El aviso al FPV debe realizarse dentro de los últimos {{ noticeDays() }} días corridos (Art. VII.4).
            </span>
          </div>

          <div class="mb-3">
            <div class="form-check form-switch p-2 rounded border border-gray-subtle bg-light">
              <input class="form-check-input ms-0" type="checkbox" id="detailIsDriverSameAsPartyForm"
                     [ngModel]="isDriverSameAsParty()" (ngModelChange)="isDriverSameAsParty.set($event); onDriverSameChange()">
              <label class="form-check-label fw-semibold ms-3 text-dark small" for="detailIsDriverSameAsPartyForm">
                ¿El conductor es el mismo Socio?
              </label>
            </div>
          </div>

          @if (canToggleNegligence) {
            <div class="mb-3">
              <div class="form-check form-switch p-2 rounded border border-gray-subtle bg-light">
                <input class="form-check-input ms-0" type="checkbox" id="detailIsNegligence"
                       [ngModel]="isNegligence()" (ngModelChange)="onNegligenceToggle($event)">
                <label class="form-check-label fw-semibold ms-3 text-dark small" for="detailIsNegligence">
                  ¿Es Negligencia? (deducible de esta línea)
                </label>
              </div>
            </div>
          }

          @if (!isDriverSameAsParty()) {
            <div class="row g-2 mb-3">
              <div class="col-12 col-md-6">
                <label class="form-label fw-semibold text-dark small">Nombre Conductor *</label>
                <input type="text" class="form-control form-control-sm" [ngModel]="driverName()" (ngModelChange)="driverName.set($event); updateModel()" placeholder="Nombre completo">
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold text-dark small">RUT Conductor *</label>
                <input type="text" class="form-control form-control-sm" [ngModel]="driverLicense()" (ngModelChange)="driverLicense.set($event); updateModel()" placeholder="12.345.678-9">
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold text-dark small">Clase Licencia *</label>
                <input type="text" class="form-control form-control-sm" [ngModel]="driverLicenseClass()" (ngModelChange)="driverLicenseClass.set($event); updateModel()" placeholder="Ej: Clase B">
              </div>
            </div>
          }

          <div class="mb-3">
            <label class="form-label fw-semibold text-dark small">Breve Reseña / Descripción del Accidente *</label>
            <textarea class="form-control form-control-sm"
              [ngModel]="description()"
              (ngModelChange)="description.set($event); updateModel()"
              [minlength]="descriptionMin"
              [maxlength]="descriptionMax"
              rows="8"
              placeholder="Describa brevemente cómo ocurrió este accidente..."></textarea>
            <div class="d-flex justify-content-between mt-1">
              <span class="text-muted" style="font-size: 10px;">Mín. {{ descriptionMin }} · Máx. {{ descriptionMax }} caracteres</span>
              <span class="text-muted" style="font-size: 10px;" [class.text-danger]="description().trim().length > 0 && description().trim().length < descriptionMin">
                {{ description().length }}/{{ descriptionMax }}
              </span>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label fw-semibold text-dark small">Descripción de los Daños Físicos *</label>
            <textarea class="form-control form-control-sm"
              [ngModel]="damageDescription()"
              (ngModelChange)="damageDescription.set($event); updateModel()"
              [minlength]="damageDescriptionMin"
              [maxlength]="damageDescriptionMax"
              rows="4"
              placeholder="Describa el daño físico observado..."></textarea>
            <div class="d-flex justify-content-between mt-1">
              <span class="text-muted" style="font-size: 10px;">Mín. {{ damageDescriptionMin }} · Máx. {{ damageDescriptionMax }} caracteres</span>
              <span class="text-muted" style="font-size: 10px;" [class.text-danger]="damageDescription().trim().length > 0 && damageDescription().trim().length < damageDescriptionMin">
                {{ damageDescription().length }}/{{ damageDescriptionMax }}
              </span>
            </div>
          </div>

          @if (!isTotalLoss()) {
            <div class="row g-2 mb-3">
              <div class="col-6 col-md-4">
                <label class="form-label fw-semibold text-dark small">Mano de Obra ($)</label>
                <input type="text" inputmode="numeric" class="form-control form-control-sm" appNumberFormat
                  [ngModel]="laborCostDisplay()" (ngModelChange)="onMoneyChange('labor', $event)">
              </div>
              <div class="col-6 col-md-4">
                <label class="form-label fw-semibold text-dark small">Repuestos / Pintura ($)</label>
                <input type="text" inputmode="numeric" class="form-control form-control-sm" appNumberFormat
                  [ngModel]="partsCostDisplay()" (ngModelChange)="onMoneyChange('parts', $event)">
              </div>
              <div class="col-12 col-md-4">
                <label class="form-label fw-semibold text-dark small">Deducible línea ($)</label>
                <input type="text" class="form-control form-control-sm bg-light text-danger fw-bold" [value]="deductible() > 0 ? '$' + (deductible() | number:'1.0-0':'es-CL') : '$0'" readonly>
              </div>
              <div class="col-12 mt-1">
                <span class="text-muted" style="font-size: 10px;">
                  <i class="fas fa-info-circle me-1"></i>
                  Estimado con tramo
                  <strong>{{ isNegligence() ? deductiblePercentages().negligentPercentage + '% Negligente' : deductiblePercentages().normalPercentage + '% Normal' }}</strong>.
                  El total del siniestro suma los deducibles de cada línea.
                </span>
              </div>
            </div>
          } @else {
            <div class="row g-2 mb-3">
              <div class="col-6">
                <label class="form-label fw-semibold text-dark small">Valor Comercial</label>
                <input type="text" class="form-control form-control-sm bg-light fw-bold" [value]="'$' + (vehicleValue() | number:'1.0-0':'es-CL')" readonly>
              </div>
              <div class="col-6">
                <label class="form-label fw-semibold text-dark small">Retención {{ deductiblePercentages().totalLossPercentage ?? 15 }}%</label>
                <input type="text" class="form-control form-control-sm bg-light text-danger fw-bold" [value]="deductible() > 0 ? '$' + (deductible() | number:'1.0-0':'es-CL') : '$0'" readonly>
              </div>
            </div>
          }
        </div>
        <div class="claim-detail-form-actions d-none d-md-flex flex-wrap gap-2 px-3 pb-3 mt-auto">
          <ng-content select="[claimDetailDesktopActions]"></ng-content>
        </div>
      </div>
    </div>

    <!-- Columna derecha: ubicación + partes -->
    <div class="col-md-6 d-flex">
      <div class="claim-detail-side">
        <div class="panel claim-detail-side-panel">
          <div class="panel-header p-3 mb-0 bg-none d-flex justify-content-between align-items-center">
            <span class="fw-semibold"><i class="fas fa-map-marker-alt me-2"></i>Ubicación</span>
          </div>
          <div class="panel-body p-3 pt-0 claim-detail-side-body">
            <app-location-picker
              [address]="geographicLocation()"
              [latitude]="latitude()"
              [longitude]="longitude()"
              [readOnly]="false"
              (locationChange)="onLocationChange($event)">
            </app-location-picker>
          </div>
        </div>

        @if (!isTotalLoss()) {
          <div class="panel claim-detail-side-panel claim-detail-side-panel--parts">
            <div class="panel-header p-3 mb-0 bg-none d-flex justify-content-between align-items-center">
              <span class="fw-semibold"><i class="fas fa-car me-2"></i>Partes afectadas</span>
              <span class="badge bg-secondary text-uppercase">{{ selectedVehicleType() }}</span>
            </div>
            <div class="panel-body p-3 pt-0 claim-detail-side-body">
              <app-vehicle-damage-selector
                [vehicleType]="selectedVehicleType()"
                [initialSelectedParts]="affectedParts()"
                [readOnly]="false"
                [showSelectedList]="false"
                [compact]="true"
                (partsSelected)="onPartsSelected($event)">
              </app-vehicle-damage-selector>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
